import { createContext, ReactNode } from "react";
import { useZoomClient } from "./hooks/use-zoom-client";
import { ZoomClient } from "./index-types";

export const ZoomContext = createContext<ZoomClient | null>(null);

export const ZoomClientProvider = ({ children }: { children: ReactNode }) => {
  const zmClient = useZoomClient();

  return (
    <ZoomContext.Provider value={zmClient}>{children}</ZoomContext.Provider>
  );
};
